import API_URL from './api';
import { useState } from 'react';
import logo from './logo.png';
import './App.css';

// R1: Functional Components — Login is a functional component
// rendered by App.js onto the screen.

// R2: Passing Props — App.js passes onLoginSuccess and onGoToSignup
// down to Login as props.
function Login({ onLoginSuccess, onGoToSignup }) {

  // R6: React Hooks — useState manages email input, OTP input,
  // which step we're on, and any error messages.
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState('email');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  async function handleSendOTP() {
    if (!email) {
      setError('Please enter your email');
      return;
    }
    setIsLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setStep('otp');
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError('Could not connect to server');
    }

    setIsLoading(false);
  }

  async function handleVerifyOTP() {
    if (!otp) {
      setError('Please enter your verification code');
      return;
    }
    setIsLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_URL}/auth/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp }),
      });

      const data = await res.json();

      if (res.ok) {
        // R2: Passing Props — calling onLoginSuccess prop from App.js
        onLoginSuccess(data);
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError('Could not connect to server');
    }

    setIsLoading(false);
  }

  const header = (
    <div className="login-header">
      <img src={logo} className="login-logo" alt="ThePinBook" />
      <span className="login-title">ThePinBook</span>
    </div>
  );

  // Step 1 — Email entry
  if (step === 'email') {
    return (
      <div>
        {header}
        <div className="form-box">
          <h2>Log in</h2>
          <p className="form-subtitle">Enter your email to receive a verification code</p>
          {error && <p className="error">{error}</p>}
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSendOTP()}
          />
          <button onClick={handleSendOTP} disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send verification code'}
          </button>
          <p>Don't have an account? <span className="link" onClick={onGoToSignup}>Sign up</span></p>
        </div>
      </div>
    );
  }

  // Step 2 — OTP entry
  return (
    <div>
      {header}
      <div className="form-box">
        <h2>Enter your code</h2>
        <p className="form-subtitle">We sent a 6-digit code to <strong>{email}</strong></p>
        {error && <p className="error">{error}</p>}
        <input
          type="text"
          placeholder="6-digit code"
          value={otp}
          maxLength={6}
          onChange={(e) => setOtp(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleVerifyOTP()}
        />
        <button onClick={handleVerifyOTP} disabled={isLoading}>
          {isLoading ? 'Verifying...' : 'Verify code'}
        </button>
        <p><span className="link" onClick={() => setStep('email')}>← Back</span></p>
      </div>
    </div>
  );
}

export default Login;